import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/system";
import { actaSchema, handleActaSubmit } from "./handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import SelectInput from "../../components/ReactHookForm/SelectInput";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import MapaActa from "./MapaActa";
import { axios } from "../../utils/axios";
import HelperText from "../../components/HelperText";

const FormCargarActa = ({ setCargarActaModalIsOpen, setActas }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [articulos, setArticulos] = useState(null);
  const [articulosSeleccionados, setArticulosSeleccionados] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(actaSchema),
  });

  useEffect(() => {
    const getArticulos = async () => {
      const result = await axios().get("get_articulos");
      const { data, error } = result.data;
      if (data) {
        let arts = data.map((articulo) => ({
          value: articulo.id,
          label: articulo.descripcion,
          data: articulo,
        }));
        setArticulos(arts);
      }
      if (error) {
        toast.error(error, toastOptions);
      }
    };

    getArticulos();
  }, []);

  return (
    <Form onSubmit={handleSubmit((data) => handleActaSubmit(data, articulosSeleccionados, setActas, setCargarActaModalIsOpen, setIsLoading))}>
      <fieldset disabled={isLoading}>
        <TextInput name='patente' label='Patente *' register={register} errors={errors?.patente} className='text-uppercase' />
        <HelperText>Autos: XXX999 / XX999XX - Motos: 999XXX / X999XXX</HelperText>
        <TextInput name='documento' label='Documento del Conductor' register={register} errors={errors?.documento} className='text-uppercase' />
        <MapaActa register={register} errors={errors} clearErrors={clearErrors} setValue={setValue} />
        <SelectInput name={`dependencia`} errors={errors?.dependencia} label='Dependencia *' register={register} value='DTM' valueName='DTM' data={[{ id: "DTP", name: "DTP" }]} />
        <TextInput name='numero_acta' label='Número de Acta *' register={register} errors={errors?.numero_acta} className='text-uppercase' />
        <div>
          <Form.Label>Foto del Acta {/* * */}</Form.Label>
          <Form.Control {...register(`file_acta`)} type='file' accept='image/jpeg, image/png, image/jpg, image/webp' style={{ border: errors?.file_acta ? "1px solid #dc3444" : "1px solid #dee2e6" }} />
          <p className='text-danger mb-0 mt-2'>{errors?.file_acta?.message}</p>
        </div>
        <div className='mb-3'>
          <Form.Label>Articulos</Form.Label>
          <Select onChange={(e) => setArticulosSeleccionados(e)} closeMenuOnSelect={false} isMulti placeholder='Seleccionar articulo/s' options={articulos} />
          {articulosSeleccionados.length === 0 ? <HelperText>Si no selecciona ningún articulo no se va generar un recibo de pago voluntario.</HelperText> : null}
        </div>
      </fieldset>

      <HelperText className='fw-bold'> Los campos marcados con * son requeridos. </HelperText>

      <div className='d-flex flex-wrap gap-2'>
        <Button type='submit' disabled={isLoading}>
          {isLoading ? (
            <Box className='w-full h-full'>
              <ContainedMuniSpinner height={25} width={25} size={35} />{" "}
            </Box>
          ) : (
            "Cargar Acta"
          )}
        </Button>
        <Button variant='danger' onClick={() => setCargarActaModalIsOpen(false)}>
          Cancelar
        </Button>
      </div>
    </Form>
  );
};

export default FormCargarActa;
